/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {shallowEqual, useSelector} from 'react-redux';
import {Layout} from '../_metronic/layout';
import BasePage from './BasePage';
import {AuthPage, Logout} from './modules/Auth';
import GlobalMessage from './modules/_common/components/GlobalMessage';
import ProgressBarPopUp from './modules/_common/components/ProgressBarPopUp';
import ErrorsPage from './modules/ErrorsExamples/ErrorsPage';
import withRefreshToken from './modules/Auth/components/withRefreshToken';

function GlobalRoutes() {
  const {isAuthorized} = useSelector(({auth}) => ({isAuthorized: auth.user != null}), shallowEqual);

  return (
    <Switch>
      {!isAuthorized ? <Route><AuthPage/></Route> : <Redirect from="/auth" to="/users"/>}
      <Route path="/error" component={ErrorsPage}/>
      <Route path="/logout" component={Logout}/>
      {!isAuthorized
        ? <Redirect to="/auth/login"/>
        : (
          <Layout>
            <BasePage/>
            <GlobalMessage/>
            <ProgressBarPopUp/>
          </Layout>
        )}
    </Switch>
  );
}

export const Routes = withRefreshToken(GlobalRoutes);
